import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';


const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "At Mobikode Qatar, we’re here to support your business with reliable solutions, responsive service, and genuine care.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise",
        description: "At Mobikode Qatar, we build thoughtful digital solutions that help businesses grow, connect, and succeed.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "At Mobikode Qatar, we build practical digital solutions that simplify work, meet your goals, and drive lasting growth.",
        image: "/assets/mumbai/img2.png"
    },
];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode Qatar, we help financial businesses work smarter, serve customers better, and grow with secure, reliable, and innovative technology built for their needs.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help Qatar’s eCommerce businesses grow with smart, reliable digital solutions that improve customer experiences, strengthen brands, and drive lasting success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Qatar’s insurance companies work smarter, serve customers better, simplify claims and policy management, and grow confidently with secure, reliable, and innovative digital solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode Qatar, we help businesses work smarter through practical technology, simpler operations, and efficient processes that improve productivity and support sustainable growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode Qatar, we create simple digital solutions that help retail and consumer brands delight customers, streamline operations, and grow with confidence.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode Qatar, we help healthcare and life sciences organizations use technology to simplify care, empower people, streamline operations, and create better digital health experiences.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode helps media and communication businesses in Qatar turn ideas into meaningful digital experiences, combining technology, creativity, and innovation to connect audiences and strengthen brands.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help Qatar’s logistics and transportation businesses simplify operations, deliver better customer experiences, and grow confidently with practical, reliable digital solutions.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode Qatar, we turn ideas into meaningful digital solutions, combining creativity, technology, and expertise to help businesses grow, connect, and succeed.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we help organizations across Qatar use technology to connect with people, simplify everyday work, and create meaningful, lasting impact in their communities.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode Qatar, we help professional service businesses simplify everyday processes, adopt smarter technology, and deliver seamless digital experiences that build trust and lasting client relationships.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode Qatar, we help real estate businesses grow through smart digital solutions that simplify operations, enhance customer experiences, and build lasting connections.",
        image: "/assets/mumbai/item12.png"
    },
];

function Qatar() {
    return (
        <div>
       <Helmet>
    <title>
        ServiceNow Consulting in Qatar | ITSM & Automation | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode provides ServiceNow consulting in Qatar for ITSM, workflow automation, platform implementation, system integration, and Enterprise AI & ServiceNow Consulting to improve enterprise operations."
    />

    <meta
        name="keywords"
        content="ServiceNow Consulting Qatar, ServiceNow Consultant Qatar, ServiceNow Implementation Qatar, ServiceNow ITSM Qatar, ServiceNow Integration Qatar, ServiceNow Automation Qatar, ServiceNow Managed Services Qatar, ServiceNow Development Qatar, ServiceNow Solutions Qatar, ServiceNow Consulting Company Qatar, ServiceNow ITSM Consulting Qatar"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-qatar"
    />

    {/* Open Graph */}
    <meta
        property="og:title"
        content="ServiceNow Consulting in Qatar | ITSM & Automation | Mobikode"
    />

    <meta
        property="og:description"
        content="Mobikode offers ServiceNow consulting in Qatar for ITSM, implementation, workflow automation, system integration, and Enterprise AI & ServiceNow Consulting to help businesses build efficient digital operations."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-qatar"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/melbourne/bg1.png"
    />

    {/* Twitter Card */}
    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="ServiceNow Consulting in Qatar | ITSM & Automation | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore ServiceNow consulting in Qatar from Mobikode for ITSM, implementation, workflow automation, system integration, and scalable Enterprise AI & ServiceNow Consulting solutions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/melbourne/bg1.png"
    />
</Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Qatar" description="Partner with Mobikode’s ServiceNow experts in Qatar to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/qatar.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />

            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Qatar
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Qatar to simplify operations, automate workflows, empower teams, and grow.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Melbourne.png"}
                text={"At Mobikode Qatar, we help businesses get more from ServiceNow with practical, tailored consulting. From implementation and customization to seamless integrations and ongoing support, our team makes complex workflows simpler and everyday processes smarter. We focus on improving efficiency, creating better user experiences, and building scalable ServiceNow solutions that help businesses grow, adapt, and confidently move forward."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode Qatar, we make ServiceNow work smarter for your business through tailored consulting, automation, and solutions that simplify work, boost efficiency, and deliver better experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Qatar
